import React, { forwardRef, Fragment, useState } from 'react';
import { Placement } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, color } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isFunction, resolveBackgroundColor } from '@philips-internal/oswald-ui-utils';
import { useIsMobileResolution } from '../../hooks/use-is-mobile-resolution.js';
import { Popover } from '../popover/popover.js';
import { SlideUpPanel } from '../slide-up-panel/slide-up-panel.js';
import { ColorInputAPI } from './color-input-api.js';
import { ColorPicker } from './color-picker/color-picker.js';
import './color-input.css';
const awesomeProps = {
    api: ColorInputAPI,
    type: ComponentType.DATA_ENTRY,
};
const ColorButton = forwardRef((props, ref) => {
    return (React.createElement("button", { className: "c-color-input__button", disabled: !props.enabled, onClick: props.onColorOpen, ref: ref, style: resolveBackgroundColor(props.value) }));
});
ColorButton.displayName = ColorButton.name;
function ColorDesktop(props) {
    return (React.createElement(Popover, { onClose: props.onColorClose, open: props.open, padding: 8, placement: Placement.RIGHT },
        React.createElement(ColorButton, { ...props }),
        React.createElement(Popover.Content, null,
            React.createElement(ColorPicker, { onClick: props.onColorClick, selected: props.value }))));
}
function ColorMobile(props) {
    return (React.createElement(Fragment, null,
        React.createElement(ColorButton, { ...props }),
        React.createElement(SlideUpPanel, { closeable: true, onClose: props.onColorClose, open: props.open },
            React.createElement(SlideUpPanel.Content, { className: "c-color-input__content" },
                React.createElement(ColorPicker, { onClick: props.onColorClick, selected: props.value })))));
}
function ColorInput(props) {
    const [open, setOpen] = useState(false);
    const isMobile = useIsMobileResolution();
    const onColorClose = () => {
        if (isFunction(props.onBlur)) {
            props.onBlur();
        }
        setOpen(false);
    };
    const onColorClick = (color) => {
        if (!isFunction(props.onChange)) {
            return;
        }
        const value = !color || props.value === color
            ? undefined
            : color;
        props.onChange(new ChangeEvent({
            oldValue: props.value,
            value,
        }));
    };
    const onColorOpen = () => {
        const { enabled = ColorInput.defaultProps.enabled, readOnly } = props;
        if (readOnly || !enabled) {
            return;
        }
        setOpen(true);
    };
    const colorAttributeProps = {
        ...props,
        onColorClick,
        onColorClose,
        onColorOpen,
        open,
    };
    return (React.createElement("div", { className: "c-color-input" }, isMobile
        ? React.createElement(ColorMobile, { ...colorAttributeProps })
        : React.createElement(ColorDesktop, { ...colorAttributeProps })));
}
ColorInput.propTypes = {
    enabled: bool,
    value: color,
};
ColorInput.defaultProps = {
    enabled: true,
};
AwesomeComponent(awesomeProps)(ColorInput);
export { ColorInput, };
//# sourceMappingURL=color-input.js.map